/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Loading from "../Loading";
import { useTranslation } from 'react-i18next';
import ThemedPageFrame from './UserComponent/ThemedPageFrame';
const Faq = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);
    const [faqList, setFaqList] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const UserId = localStorage.getItem("Userid");
        if (UserId) {
            axios.post(`${BaseUrl}user_api/u_faq.php`, { uid: UserId, lats: 26.9124, longs: 75.7873 })
                .then((res) => {
                    setFaqList(res.data.FaqData);
                    setLoading(false);
                })
                .catch((error) => {
                    setFaqList([]);
                    setLoading(false);
                });
        }
    }, []);

    const handleChange = (index) => {
        if (expandedIndex.includes(index)) {
            setExpandedIndex(expandedIndex.filter(id => id !== index));
        } else {
            setExpandedIndex([...expandedIndex, index]);
        }
    };

    return (
        <ThemedPageFrame
            activePath="/faq"
            eyebrow="Support"
            title={t("Helps & FAQs")}
            subtitle={t("Frequently asked questions")}
            summary={<><span>Questions</span><strong>{faqList?.length || 0}</strong></>}
            className="legacy_themed_page faq_page_layout"
        >
            {!loading ? <div className="bg-[#373737] p-[30px] rounded-[30px] mt-[20px]">
                <div className="">
                    <span className='text-[15px] text-white'>{t("Frequently asked questions")}</span>
                    <h1 className="font-bold text-[28px] sm:text-[34px] md:text-[40px] lg:text-[48px] text-white">
                        {t("Helps & FAQs")}
                    </h1>
                </div>
                <div className="mt-[20px]">
                    {faqList.map((item, index) => {
                        const isExpanded = expandedIndex.includes(index);
                        return (
                            <div key={index} className="mb-[8px]">
                                <Accordion style={{
                                    border: isExpanded ? '1px solid #b38b2e' : '1px solid #e1e1e1', borderRadius: "10px"
                                }} expanded={isExpanded} onChange={() => handleChange(index)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon style={{ color: isExpanded ? '#b38b2e' : 'gray' }} />}
                                        aria-controls={`panel${index}-content`}
                                        id={`panel${index}-header`}
                                    >
                                        <Typography component="span">{item.question}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className='text-white'>{item.answer}</AccordionDetails>
                                </Accordion>
                            </div>
                        );
                    })}
                </div>
            </div>
                : <Loading />
            }
        </ThemedPageFrame>
    )
}

export default Faq
/* jshint ignore:end */
